// ABOUTME: Icon component for collapse all - chevrons pointing inward
// ABOUTME: Used for accordion/group collapse all functionality

interface IconProps {
  className?: string
  size?: number
  color?: string
}

export const ChevronsCollapseIcon = ({ className = "", size = 16, color = "currentColor" }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M7 4l5 5 5-5M7 20l5-5 5 5"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
